import qs from "qs";
import { REGION_NA, REGION_SA } from "../service/Constants";

function mapRegionToDriverFilters(region) {
  switch (region) {
    case REGION_NA:
      return [
        {
          title: "Release state",
          filters: ["releaseState"]
        },
        {
          title: "Dimming interface",
          filters: ["driverDimmingType"]
        },
        {
          title: "Dimming range",
          filters: ["hasMinimalDimmingCurrent"]
        },
        {
          title: "Set output current",
          filters: ["driverConfigurability"]
        },
        {
          title: "Application",
          filters: ["driverFamilyFilter_1"]
        },
        {
          title: "Series",
          filters: ["driverFamilyFilter_2"]
        },
        {
          title: "Family",
          filters: ["driverFamilyFilter_3"]
        },
        {
          title: "Features",
          filters: ["driverFeature"]
        },
        {
          title: "Classifications",
          filters: ["driverClassification"]
        },
        {
          title: "Input voltage",
          filters: ["driverInputVoltages"]
        },
        {
          title: "Certifications",
          filters: ["driverCertification"]
        },
        {
          title: "Dimensions",
          filters: [
            "driverHousingWidth",
            "driverHousingLength",
            "driverHousingHeight"
          ]
        },
        {
          title: "Exceptions",
          filters: ["searchTermFilter"]
        },
        {
          title: "Single currents",
          filters: ["singleCurrent"]
        },
        {
          title: "VPK",
          filters: ["vpk"]
        }
      ];
    case REGION_SA:
      return [
        {
          title: "Release state",
          filters: ["releaseState"]
        },
        {
          title: "Application",
          filters: ["driverFamilyFilter_1"]
        },
        {
          title: "Series",
          filters: ["driverFamilyFilter_2"]
        },
        {
          title: "Family",
          filters: ["driverFamilyFilter_3"]
        },
        {
          title: "Driver type",
          filters: ["driverType"]
        },
        {
          title: "Input voltage",
          filters: ["driverInputVoltages"]
        },
        {
          title: "Dimming interface",
          filters: ["driverDimmingType"]
        },
        {
          title: "Features",
          filters: ["driverFeature"]
        },
        {
          title: "Set output current",
          filters: ["driverConfigurability"]
        },
        {
          title: "Dimensions",
          filters: [
            "driverHousingWidth",
            "driverHousingLength",
            "driverHousingHeight"
          ]
        },
        {
          title: "Exceptions",
          filters: ["searchTermFilter"]
        },
        {
          title: "Single currents",
          filters: ["singleCurrent"]
        },
        {
          title: "VPK",
          filters: ["vpk"]
        }
      ];
    default: {
      return [
        {
          title: "Release state",
          filters: ["releaseState"]
        },
        {
          title: "Application",
          filters: ["driverFamilyFilter_1"]
        },
        {
          title: "Series",
          filters: ["driverFamilyFilter_2"]
        },
        {
          title: "Family",
          filters: ["driverFamilyFilter_3"]
        },
        {
          title: "Dimming interface",
          filters: ["driverDimmingType"]
        },
        {
          title: "Set output current",
          filters: ["driverConfigurability"]
        },
        {
          title: "Features",
          filters: ["driverFeature"]
        },
        {
          title: "Isolation class",
          filters: ["driverIsolationClass"]
        },
        {
          title: "Mounting type",
          filters: ["driverMountingType"]
        },
        {
          title: "DC Emergency",
          filters: ["driverDcEmergency"]
        },
        {
          title: "Dimensions",
          filters: [
            "driverHousingWidth",
            "driverHousingLength",
            "driverHousingHeight"
          ]
        },
        {
          title: "Exceptions",
          filters: ["searchTermFilter"]
        },
        {
          title: "Single currents",
          filters: ["singleCurrent"]
        },
        {
          title: "V-open-load",
          filters: ["vpk"]
        }
      ];
    }
  }
}

export const mapDriverFilterToType = {
  release_state: "checkbox",
  driverFamilyFilter_1: "checkbox",
  driverFamilyFilter_2: "checkbox",
  driverFamilyFilter_3: "checkbox",
  family: "checkbox",
  dimmming_interface: "checkbox",
  mounting_type: "checkbox",
  iso_class: "checkbox",
  dc_emergency: "checkbox",
  set_out_current: "checkbox",
  driverHousingWidth: "range",
  driverHousingLength: "range",
  driverHousingHeight: "range",
  searchTermFilter: "search",
  vpk: "range"
};

export const mapDriverFilterToParameter = {
  driverFamilyFilter_1: "productFamily",
  driverFamilyFilter_2: "productFamily2",
  driverFamilyFilter_3: "productFamily3",
  mounting_type: "mountingTypes",
  dimmming_interface: "dimmingTypes",
  special_spectrum: "specialSpectrum",
  release_state: "releaseState",
  searchTermFilter: "searchTerm",
  driverHousingWidth: ["housingWidthMin", "housingWidthMax"],
  driverHousingLength: ["housingLengthMin", "housingLengthMax"],
  driverHousingHeight: ["housingHeightMin", "housingHeightMax"],
  hasMinimalDimmingCurrent: "driverMinimalDimmingCurrentMatch",
  vpk: ["vpkMin", "vpkMax"]
};

function lookupFilterToType(name) {
  return !mapDriverFilterToType[name]
    ? "checkbox"
    : mapDriverFilterToType[name];
}

function lookupFilterToParameter(name) {
  return !mapDriverFilterToParameter[name]
    ? name
    : mapDriverFilterToParameter[name];
}

function mapDriverFilters(region, input) {
  return [
    ...mapRegionToDriverFilters(region).map(group => {
      return {
        title: group.title,
        filters: group.filters.map(name => {
          const type = lookupFilterToType(name);
          const [filter] = input
            .filter(item => item.name === name)
            .map(item => {
              if (item.name === "hasMinimalDimmingCurrent") {
                const availableValues = item.availableValues.filter(
                  x => x.value !== "false"
                );
                availableValues.find(x => x.value === "true").value =
                  "Support minimum level";
                item.availableValues = availableValues;
                if (item.value) {
                  item.value = ["Support minimum level"];
                }
              }
              return item;
            });

          const driverFilter = {
            type,
            ...filter
          };

          switch (name) {
            case "driverHousingWidth":
              driverFilter.displayName = "Housing width";
              break;
            case "driverHousingLength":
              driverFilter.displayName = "Housing length";
              break;
            case "driverHousingHeight":
              driverFilter.displayName = "Housing height";
              break;
            default:
              driverFilter.displayName = name;
              break;
          }

          return driverFilter;
        })
      };
    })
  ];
}

/**
 *
 * @param filters
 * @param driverCurrent
 * @param driverVoltage
 * @param driverPower
 * @param driverPerformancePower
 * @param driverSearchTerm
 * @returns {{targetCurrent: number, targetVoltage: *, targetPower: *}}
 */
function mapDriverFilterState({
  filters,
  driverCurrent,
  driverVoltage,
  driverPower,
  driverPerformancePower,
  driverSearchTerm
}) {
  // Add parameters
  const parameters = {};

  if (driverCurrent) {
    parameters.targetCurrent = driverCurrent / 1000;
  }

  if (driverVoltage) {
    parameters.targetVoltage = driverVoltage;
  }

  if (driverPower) {
    parameters.targetPower = driverPower;
  }

  if (driverPerformancePower) {
    parameters.driverPowerPerformanceMatch = driverPerformancePower;
  }

  // Add filters
  filters.forEach(group => {
    group.filters.forEach(filter => {
      const paramName = lookupFilterToParameter(filter.name);
      if (lookupFilterToType(filter.name) === "range") {
        //So if it is an range filter it will have a min and max property
        if (filter.value) {
          //if value is single value then...
          if (filter.value.min && filter.value.max) {
            //The min parameter
            parameters[paramName[0]] = filter.value.min;
            //The max parameter
            parameters[paramName[1]] = filter.value.max;
          } else {
            //What we get back from the backend
            //The min parameter
            parameters[paramName[0]] = filter.from;
            //The max parameter
            parameters[paramName[1]] = filter.to;
          }
        }
      } else if (filter.name === "hasMinimalDimmingCurrent") {
        if (filter.value != null && filter.value.length) {
          parameters[paramName] = "true";
        }
      } else {
        let filterValue = null;
        if (filter.value != null) {
          // Prevent setting a filter value that the module doesn't have.
          if (Array.isArray(filter.value)) {
            filterValue = [];
            filter.value.map(value => {
              if (
                filter.availableValues.some(
                  availableValue => availableValue.value === value
                )
              ) {
                filterValue.push(value);
              }
            });
          } else {
            filterValue = filter.value;
          }
          parameters[paramName] = filterValue;
        }
      }
    });
  });

  //Set this after all the filters are applied cause then the most recent searchTerm will be send to the backend and saved
  //If you put this before the 'Add filters forEach loop' then the saved searchTerm value will be added
  if (driverSearchTerm) {
    parameters["searchTerm"] = driverSearchTerm;
  } else {
    if (driverSearchTerm === "") {
      parameters["searchTerm"] = "";
    }
  }
  return parameters;
}

function mapDriverFilterQueryParameters(filters) {
  return (
    "?" +
    qs.stringify(
      filters.reduce((params, filter) => {
        params[filter.field] = filter.value;
        return params;
      }, {})
    )
  );
}

export {
  mapDriverFilters,
  mapDriverFilterState,
  mapDriverFilterQueryParameters
};
